// extracted by mini-css-extract-plugin
export default {"root":"Error_root__DYbCy","wrapper":"Error_wrapper__Ms0+P","message":"Error_message__baeVq","footer":"Error_footer__0Rq1Q"};